import { render, staticRenderFns } from "./CertificationsTermsEditForm.vue?vue&type=template&id=5806cd5c&"
import script from "./CertificationsTermsEditForm.vue?vue&type=script&lang=js&"
export * from "./CertificationsTermsEditForm.vue?vue&type=script&lang=js&"
import style0 from "./CertificationsTermsEditForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports